module.exports = __webpack_public_path__ + "static/media/pplogo-192-health.41ade606.png";